export default __webpack_public_path__ + "static/media/consultant.d4fa2151.svg";